import { getText } from '@storebrand-digital/fms-translations';
import { Segment, SegmentId } from '../../utils/segments';

export const mainColumns = [
  {
    name: 'DOCUMENT_NAME',
    label: () => getText('documents.table.documentName.label'),
    className: 'document-name',
    sortable: true,
    align: 'left',
  },
  {
    name: 'DOCUMENT_CONTRACT_NUMBER',
    label: () => getText('documents.table.contractNumber.label'),
    className: 'document-contract-number',
    sortable: false,
    align: 'left',
  },
  {
    name: 'DOCUMENT_DATE',
    label: () => getText('documents.table.date.label'),
    className: 'document-date',
    sortable: true,
    align: 'right',
  },
] as const;

export const bankColumns = [
  {
    name: 'DOCUMENT_NAME',
    label: () => getText('documents.table.documentName.label'),
    className: 'document-name',
    sortable: true,
    align: 'left',
  },
  {
    name: 'DOCUMENT_ACCOUNT_NUMBER',
    label: () => getText('documents.table.bank.accountNumber.label'),
    className: 'document-contract-number',
    sortable: false,
    align: 'left',
  },
  {
    name: 'DOCUMENT_DATE',
    label: () => getText('documents.table.date.label'),
    className: 'document-date',
    sortable: true,
    align: 'right',
  },
] as const;

export const getColumns = (segmentId: SegmentId) => {
  switch (segmentId) {
    case Segment.BANK:
      return bankColumns;
    case Segment.MAIN:
    default:
      return mainColumns;
  }
};
